export default {"src":"/_next/static/media/CLVT.c3bd8329.svg","height":18,"width":18};